import styled from 'styled-components';
import { BodyRegularL, DefaultButton } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const SessionExpiredCont = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.deka} 0 0;
  `}
`;

export const ExpiredTitle = styled(BodyRegularL)`
  max-width: 500px;
  text-align: center;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]}
  `}
`;

export const GoToLoginButton = styled(DefaultButton)`
  width: 320px;
  border-radius: 8px;
  outline: none;
  border: none;

  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.deka} 0 0 0;
    background: ${theme.colors.primary[100]};
    color: ${theme.colors.neutral.primary[5]};
  `}
`;
